<template>
    <div >
        <vx-card class="no-scroll-content" title="List of Filed Leaves" >
            <!-- <p>You can have a sebra effect by adding the property <code>stripe</code></p><br> -->
            <vs-button type="gradient" color="primary" @click="promptAddNewLeave()" icon-pack="feather" icon="icon-file">Apply Leave</vs-button>
                <vs-table class="no-scroll-content" stripe max-items="12" pagination v-model="selected"  search :data="getEmployeeLeaveRequests">

                    <template slot="thead">
                        <vs-th sort-key="createdOn">Date Applied</vs-th>
                        <vs-th sort-key="leaveTypeId">Leave Type</vs-th>
                        <vs-th sort-key="fromDate">From Date</vs-th>
                        <!-- <vs-th>To Date</vs-th> -->
                        <vs-th>No Of Days</vs-th>
                        <vs-th>Reason</vs-th>
                        <vs-th>Approvers</vs-th>
                        <vs-th><vs-icon  color="primary" icon-pack="feather" icon="icon-paperclip"  /></vs-th>
                        <vs-th>Status</vs-th>
                        <vs-th>My Remarks</vs-th>
                        <vs-th>Approver Remarks</vs-th>
                        <vs-th>Actions</vs-th>
                    </template>

                    <template slot-scope="{data}">
                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td :data="data[indextr].createdOn">
                            {{data[indextr].createdOn | fulldate}}
                        </vs-td>
                        <vs-td :data="data[indextr].leaveTypeId">
                            {{  leaveType(data[indextr].leaveTypeId).leaveTypeName }}
                        </vs-td>
                        <vs-td :data="data[indextr].fromDate">
                            {{data[indextr].fromDate | fulldate}} to {{data[indextr].toDate | fulldate }}
                        </vs-td>
                        <!-- <vs-td :data="data[indextr].toDate">
                            {{data[indextr].toDate | fulldate }}
                        </vs-td> -->
                        <vs-td :data="data[indextr].noOfDays">
                            {{data[indextr].noOfDays}}
                        </vs-td>
                        <vs-td :data="data[indextr].reason">
                            {{data[indextr].reason}}
                        </vs-td>
                        <vs-td >
                            <ul class="users-liked user-list">
                                <li :key="indextd" v-for="(user, indextd) in data[indextr].approversLMs">
                                    <!-- {{user}} -->
                                    <vx-tooltip :text="user.approver.fullName">
                                        <vs-avatar v-if="user.approver.photoUrl != ''" class="border-2 border-white border-solid -m-1" size="30px" :src="user.approver.photoUrl" />
                                        <vs-avatar v-else class="border-2 border-white border-solid -m-1" size="30px" :text="user.approver.fullName" :color="user.approver.firstName.length <= 3 ? 'success' : user.approver.firstName.length < 6 ? 'primary' : user.approver.firstName.length < 8 ? 'warning' : user.approver.firstName.length < 10 ? 'danger' : user.approver.firstName.length < 13 ? 'dark' : user.approver.firstName.length < 15? 'success' : 'hex'"/>
                                    </vx-tooltip>
                                </li>
                            </ul>
                        </vs-td>
                        <vs-td  :data="data[indextr].fileId" >
                            <vs-icon v-show="data[indextr].fileId != [] && data[indextr].fileId != null" @click="downloadFile(data[indextr].fileId)"  color="primary" icon-pack="feather" icon="icon-paperclip"  />
                        </vs-td>
                        <vs-td :data="data[indextr].fileId">
                                <span class="flex items-center px-2 py-1 rounded">
                                    <div  :class="onGetStatus(data[indextr]) == 'Approved' ? 'h-3 w-3 rounded-full mr-2 bg-success' : 
                                        onGetStatus(data[indextr]) == 'Partially Approved' ? 'h-3 w-3 rounded-full mr-2 bg-partial' :
                                        onGetStatus(data[indextr]) == 'For Revision' ? 'h-3 w-3 rounded-full mr-2 bg-primary' :
                                        onGetStatus(data[indextr]) == 'Retracted' ? 'h-3 w-3 rounded-full mr-2 bg-dark' :
                                        onGetStatus(data[indextr]) == 'Denied' ? 'h-3 w-3 rounded-full mr-2 bg-danger' :
                                        onGetStatus(data[indextr]) == 'Draft' ? 'h-3 w-3 rounded-full mr-2 bg-draft' :
                                        onGetStatus(data[indextr]) == 'Pending' ? 'h-3 w-3 rounded-full mr-2 bg-warning' : 'h-3 w-3 rounded-full mr-2 bg-danger'"/>
                                        {{onGetStatus(data[indextr])}}
                                </span>
                        </vs-td>
                        <vs-td :data="data[indextr].remarks">
                                {{ data[indextr].remarks }}
                        </vs-td>
                        <vs-td >
                            <span :data="item" :key="index" v-for="(item, index) in data[indextr].approversLMs">
                                {{ data[indextr].approversLMs[index].comments }}
                            </span>
                        </vs-td>
                        <vs-td >
                            <div class="vx-row">
                                <div class="flex">
                                    <vx-tooltip :text="onGetStatus(data[indextr]) == 'Approved' ? 'Retract' : 
                                        onGetStatus(data[indextr]) == 'Partially Approved' ? 'Retract' :
                                        onGetStatus(data[indextr]) == 'For Revision' ? 'Edit' :
                                        onGetStatus(data[indextr]) == 'Retracted' ? '' :
                                        onGetStatus(data[indextr]) == 'Denied' ? '' :
                                        onGetStatus(data[indextr]) == 'Draft' ? 'Edit' :
                                        onGetStatus(data[indextr]) == 'Pending' ? 'Un-Submit' : ''">
                                            <feather-icon v-show="(onGetStatus(data[indextr]) == 'Approved' || onGetStatus(data[indextr]) == 'Partially Approved')  " icon="RepeatIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="onRetracted(data[indextr].employeeFiledLeaveId, data[indextr].approversLMs)" />
                                            <!-- <feather-icon v-show="(onGetStatus(data[indextr]) == 'Approved' || onGetStatus(data[indextr]) == 'Partially Approved') && getFromDate(data[indextr].fromDate) > getCurrentDate " icon="RepeatIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="onRetracted(data[indextr].employeeFiledLeaveId)" /> -->
                                            <feather-icon v-show="onGetStatus(data[indextr]) == 'Draft' || onGetStatus(data[indextr]) == 'For Revision'" icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="onEditRecord(data[indextr].employeeFiledLeaveId)" />
                                            <feather-icon v-show="onGetStatus(data[indextr]) == 'Pending'" icon="RotateCcwIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="onUnSubmit(data[indextr].employeeFiledLeaveId, data[indextr].approversLMs)" />
                                    </vx-tooltip>
                                    </div>
                                <div class="flex">
                                    <vx-tooltip text="Cancel">
                                        <feather-icon v-show="onGetStatus(data[indextr]) != 'Denied' && onGetStatus(data[indextr]) != 'Retracted' && onGetStatus(data[indextr]) != 'Cancelled'" icon="XIcon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="onCancelled(data[indextr].employeeFiledLeaveId, data[indextr].approversLMs)" />        
                                    </vx-tooltip>
                                </div>
                            </div>
                        </vs-td>
                    </vs-tr>
                </template>
            </vs-table>
        </vx-card>

        <!-- ADD LEAVE -->
        <vs-prompt
            class="email-compose"
            title="Apply Leave"
            accept-text= "Submit"
            @accept="onAddLeave"
            :is-valid="validForm"
            :active.sync="activePromptAddLeave">
            <vx-card title="Fill-out the following information" >
                    
                <component :is="scrollbarTag" class="scroll-area p-4" :settings="settings" :key="$vs.rtl">
                    <form @submit.prevent>
                        <!-- <VuePerfectScrollbar class="scroll-area" :settings="getLeaveTypes"> -->
                        <div class="vx-row mb-3">
                            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                                <span  class="text-sm">Leave Type</span><span style="color:red">*</span>
                                <v-select v-validate="'required'"  name="leaveType-name" v-model="leaveTypeName" label="leaveTypeName" :options="getLeaveBenefits"/>
                            </div>
                        </div>
                        <div class="vx-row">
                            <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 w-full mb-2">
                                <span  class="text-sm">Start Date</span><span style="color:red">*</span>
                                <flat-pickr v-validate="'required'" :disabled="isLeaveDatesDisabled"  name="start-date"   class="w-full" v-model="employeeLeaves.fromDate"  :disabledDates="disabledDates.disabledDates" @on-change="onFromChange" :config="configFromdateTimePicker" />
                            </div>
                            <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 w-full mb-2">
                                <span  class="text-sm">End Date</span><span style="color:red">*</span>
                                <flat-pickr v-validate="'required'" :disabled="isLeaveDatesDisabled" name="end-date" class="w-full" v-model="employeeLeaves.toDate"  :disabledDates="disabledDates.disabledDates"  @on-change="onToChange" :config="configTodateTimePicker"/>
                            </div>
                        </div>
                        <div class="vx-row">
                            <div class="vx-col sm:w-1/2 w-full mb-4">
                            <vs-switch v-model="employeeLeaves.isMorningFrom">
                                    <span  class="text-sm" slot="on">PM</span>
                                    <span  class="text-sm" slot="off">AM</span>
                                </vs-switch>
                            </div>
                            <div class="vx-col sm:w-1/2 w-full mb-4" >
                                <vs-switch v-model="employeeLeaves.isMorningTo">
                                    <span  class="text-sm" slot="on">PM</span>
                                    <span  class="text-sm" slot="off">AM</span>
                                </vs-switch>
                            </div>
                        </div>
                        <div class="vx-row mb-3">
                            <div class="vx-col sm:w-3/4  mb-2" >
                                <span  class="text-sm">No of Days : </span>
                                <vs-input name="no of days" v-validate="'max_value:60'" v-model="employeeLeaves.noOfDays"/>
                            </div>
                        </div>
                        <div class="vx-row mb-3">
                            <div class="vx-col w-full mb-2">
                                <span  class="text-sm">Reason</span> <span v-show="leaveTypeName === undefined ? false : leaveTypeName.isRequiredReason"  style="color:red">*</span>
                                <vs-input name="reason" class="w-full" placeholder="Reason" v-model="employeeLeaves.reason"></vs-input>
                            </div>
                        </div>
                        <div class="vx-row mb-2">
                            <div class="vx-col w-full mb-2">
                                <span class="text-sm">Approvers</span><span style="color:red">*</span>
                                <v-select name="approvers" v-validate="'required'" multiple :closeOnSelect="false" class="w-full" v-model="approverName" label="fullName" :options="getApprovers" />
                            </div>
                        </div>
                        <div class="vx-row mb-2">
                            <div class="vx-col w-full mb-2">
                                <vs-checkbox color="rgb(21, 67, 252)" v-model="employeeLeaves.isDraft">Save As Draft?</vs-checkbox>
                            </div>
                        </div>
                        <div class="vx-row" v-show="leaveTypeName === undefined ? false : leaveTypeName.isAttachment">
                            <div class="vx-col w-full mb-2" v-show="leaveTypeName === undefined ? false: employeeLeaves.noOfDays >= leaveTypeName.maxCountForAttachment ? true : false">
                                <vs-upload
                                    @change="onFilesSelected"
                                    class="compose-mail-attachment"  
                                    ref="uplodfle" 
                                    limit = 2
                                    @on-success="onSuccessUpload"
                                    @on-delete="onDeleteFile"
                                    multiple text="Attachments" 
                                    :show-upload-button="false" 
                                    :headers="{'Content-Type': 'multipart/form-data'}"
                                    accept=".doc,.jpg,.jpeg,.png,.pdf,.zip,.rar" 
                                />
                                
                            </div>
                        </div>
                        <div class="vx-row" v-show="leaveTypeName === undefined ? false : leaveTypeName.isAttachment">
                            <vs-alert :active="leaveTypeName === undefined ? false: employeeLeaves.noOfDays >= leaveTypeName.maxCountForAttachment ? true : false"  icon-pack="feather" icon="icon-info" color="warning">
                                <span>Required documents is needed as proof of your leave request.</span>
                            </vs-alert>
                        </div>
                    </form>
                </component>
            </vx-card>
        </vs-prompt>

        <!-- EDIT LEAVE -->
        <vs-prompt
            class="email-compose"
            title="Apply Leave"
            accept-text= "Submit"
            @accept="onUpdateLeave"
            :is-valid="validForm"
            :active.sync="activePromptEditLeave">
            <vx-card title="Fill-out the following information" >
                    
                <component :is="scrollbarTag" class="scroll-area p-4" :settings="settings" :key="$vs.rtl">
                    <form @submit.prevent>
                        <!-- <VuePerfectScrollbar class="scroll-area" :settings="getLeaveTypes"> -->
                        <div class="vx-row mb-3">
                            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                                <span  class="text-sm">Leave Type</span><span style="color:red">*</span>
                                <v-select :disabled=true v-validate="'required'" name="leaveType-name" v-model="leaveTypeName" label="leaveTypeName" :options="getLeaveBenefits"/>
                            </div>
                        </div>
                        <div class="vx-row">
                            <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 w-full mb-2">
                                <span  class="text-sm">Start Date</span><span style="color:red">*</span>
                                <datepicker v-validate="'required'"  name="start-date"   class="w-full" v-model="employeeLeaves.fromDate"  :disabledDates="disabledDates.disabledDates" @on-change="onFromChange" />
                            </div>
                            <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 w-full mb-2">
                                <span  class="text-sm">End Date</span><span style="color:red">*</span>
                                <datepicker v-validate="'required'"  name="end-date" class="w-full" v-model="employeeLeaves.toDate"  :disabledDates="disabledDates.disabledDates"  @on-change="onToChange" />
                            </div>
                        </div>
                        <div class="vx-row">
                            <div class="vx-col sm:w-1/2 w-full mb-4">
                            <vs-switch v-model="employeeLeaves.isMorningFrom">
                                    <span  class="text-sm" slot="on">PM</span>
                                    <span  class="text-sm" slot="off">AM</span>
                                </vs-switch>
                            </div>
                            <div class="vx-col sm:w-1/2 w-full mb-4" >
                                <vs-switch v-model="employeeLeaves.isMorningTo">
                                    <span  class="text-sm" slot="on">PM</span>
                                    <span  class="text-sm" slot="off">AM</span>
                                </vs-switch>
                            </div>
                        </div>
                        <div class="vx-row mb-3">
                            <div class="vx-col sm:w-3/4  mb-2" >
                                <span  class="text-sm">No of Days : </span>
                                <vs-input name="no of days" v-validate="'max_value:60'" v-model="employeeLeaves.noOfDays"/>
                            </div>
                        </div>
                        <div class="vx-row mb-3">
                            <div class="vx-col w-full mb-2">
                                <span  class="text-sm">Reason</span> <span v-show="leaveTypeName === undefined ? false : leaveTypeName.isRequiredReason"  style="color:red">*</span>
                                <vs-input name="reason" class="w-full" placeholder="Reason" v-model="employeeLeaves.reason"></vs-input>
                            </div>
                        </div>
                        <div class="vx-row mb-2">
                            <div class="vx-col w-full mb-2">
                                <span class="text-sm">Approvers</span><span style="color:red">*</span>
                                <v-select name="approvers" v-validate="'required'" multiple :closeOnSelect="false" class="w-full" v-model="approverName" label="fullName" :options="getApprovers" />
                            </div>
                        </div>
                        <div class="vx-row mb-2">
                            <div class="vx-col w-full mb-2">
                                <vs-checkbox color="rgb(21, 67, 252)" v-model="employeeLeaves.isDraft">Save As Draft?</vs-checkbox>
                            </div>
                        </div>
                        <div class="vx-row mb-2" v-show="leaveTypeName === undefined ? false : leaveTypeName.isAttachment">
                                <div class="vx-col w-full mb-2" :key="index"  v-for="(attachment, index) in  attachmentName">
                                    <vs-button v-show="!isFileReplaced" @click="downloadFile(attachment.value)" color="primary" type="border" :badge=3 icon-pack="feather" icon="icon-download">{{attachment.label}}</vs-button>
                                </div>
                            
                        </div>
                        <!-- <div class="vx-row mb-2" v-show="leaveTypeName === undefined ? false : leaveTypeName.isAttachment">
                            <div class="vx-col w-full mb-2">
                                <vs-upload
                                    class="compose-mail-attachment"  
                                    ref="uplodfle" 
                                    limit = 2
                                    @change="onFilesSelected" 
                                    @on-success="onSuccessUpload"
                                    @on-delete="onDeleteFile"
                                    multiple text="Attachments" 
                                    :show-upload-button="false" 
                                    :headers="{'Content-Type': 'multipart/form-data'}"
                                    accept=".doc,.jpg,.jpeg,.png,.pdf,.zip,.rar" 
                                />
                            </div>
                        </div> -->
                    </form>
                </component>
            </vx-card>
        </vs-prompt>

    </div>
</template>


<script>
import Datepicker from 'vuejs-datepicker'
import { en, he } from 'vuejs-datepicker/src/locale'

import moduleLeaveManagement from '@/store/leavemanagement/moduleLeaveManagement.js'

import moment from 'moment'
import vSelect from 'vue-select'

import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

import VuePerfectScrollbar from 'vue-perfect-scrollbar'

import Swal from 'sweetalert2'
export default {
    data() {
        return {
            selected:[],
            employeeLeaves: {
                employeeFiledLeaveId: null,
                leaveTypeId: null,
                fromDate: this.getCurrentDate,
                toDate: this.getCurrentDate,
                isMorningFrom: false,
                isMorningTo: true,
                noOfDays: 0,
                hours: 0,
                minutes: 0,
                reason: '',
                isDraft: false,
                isSubmitted: true,
                submittedOn: null,
                isCancelled: false,
                cancelledOn: null,
                remarks: '',
                fileId: '',
                photoURL:'',
                createdOn: this.getCurrentDate,
                subscriptionId: '58804fc5-45d5-46cb-a892-09fdda5824b4',
                approversLMs: [],
            },
            isLeaveDatesDisabled: true,

            filesSelected: null,

            formData: new FormData(),
            dataObject: null,

            configFromdateTimePicker : {
                enableTime: false,
                minDate: null,
                maxDate: null,
                disable: [],

            },
            configTodateTimePicker: {

                enableTime: false,
                disable: []

            },
            disabledFrom: false,
            activePromptAddLeave: false,
            activePromptEditLeave: false,
            activeUnSubmitDialog: false,
            activeRetrackDialog: false,
            activeCancelDialog: false,
            isOverlapped: false,
            // fileName:'',
            // fileType: '',
            // userId: '',
            disabledDates: [],

            attachmentName: [],

            isFileReplaced: false,
            settings: {
                maxScrollbarLength: 60,
                wheelSpeed: 0.30
            }

            // getCurrentDate: new Date(),

        }
    },
    created() {
        this.$store.registerModule('leavemanagement', moduleLeaveManagement)
        
        this.$vs.loading()
        const leaves = {
            sortBy: 'CreatedOn',
            sortOrder: 'Desc',
            pageNumber: 1,
            pageSize: -1,
            isApprover: false
        }
        this.$store.dispatch('leavemanagement/getAllLeaves', leaves)
            .then((res) => { 
                this.$vs.loading.close() 
                // this.getEmployeeLeaveRequests = res.data.data
            })
            .catch((err) => { 
                this.$vs.loading.close()
                console.log(err) 
            })
        this.$store.dispatch('tenants/getAllTenantsSchedule', { tenantsId: this.$store.state.AppActiveUser.tenantsId}).catch((err) => { console.log(err)})
        this.$store.dispatch('lookup/getAllLeaveTypeLookup').catch((err) => { console.log(err)})
        this.$store.dispatch('hrms/getAllInformation', this.$store.state.AppActiveUser.uid)  

        const data = {
            module: 2,
            userId: this.$store.state.AppActiveUser.uid
        }
        this.$store.dispatch('leavemanagement/getAllApproversByModule', data)
                .then((res) => {
                        if(res.data.data.length == 0){
                            this.$alert('Approvers has not been set', 'Leave Request', 'error');
                        }
                })
                .catch((err) => { console.log(err)})
        this.$store.dispatch('hrms/getAllLeaveBenefits', data.userId).catch((err) => { console.log(err)})
        this.$store.dispatch('hrms/getAllLeaveBalance', this.$store.state.AppActiveUser.uid)    
        
        
        // this.employeeLeaves = null


    },
    beforeDestroy () {
        this.$store.unregisterModule('leavemanagement')
    },
   watch: {
        leaveTypeName() {
            this.onDisabledDates()
            if(this.leaveTypeName != null) {
                this.configFromdateTimePicker.minDate = !this.leaveTypeName.isBackDate && this.leaveTypeName.maxDaysforBackDate > 0 ? new Date().fp_incr(-this.leaveTypeName.maxDaysforBackDate) : null
                this.isLeaveDatesDisabled =  false

            }
                
        },
        'employeeLeaves.isMorningFrom'() {
            this.getDateDiff()
        },
        'employeeLeaves.isMorningTo'() {
            this.getDateDiff()
        },
        'employeeLeaves.fromDate'() {
            if(this.employeeLeaves.toDate != null)
            this.getDateDiff()
        },
        'employeeLeaves.toDate'() {
            if(this.employeeLeaves.fromDate != null)
            this.getDateDiff()
        },
        'employeeLeaves.isDraft'() {
            if(!this.employeeLeaves.isDraft) {
                 this.employeeLeaves.isSubmitted = true
                this.employeeLeaves.submittedOn = new Date()
            }
               
        },
        onDeleteFile() {
            console.log('filesSelected')
        }
       
        

       
    },
    mounted(){
        // this.onDisabledDates()
    },
    computed : {
        getEmployeeLeaveRequests() {
            return this.$store.state.leavemanagement.employeeFiledLeaves
        },
        getEmployeeInformation() {
            return this.$store.state.hrms.employeeInformation
        },
        checkDateHired() {
            var x = moment(new Date()).local().format("YYYY-MM-DD") 
            var dateStart = moment(this.getEmployeeInformation.dateStart).local().format('YYYY-MM-DD') 
            // console.log(dateStart)
            // console.log(x)
            // console.log(moment.duration(moment(x).diff(dateStart)).asMonths())
            return moment.duration(moment(x).diff(dateStart)).asMonths() 
        },
        validForm() {
            
            return this.leaveTypeName != null  &&
            this.employeeLeaves.fromDate != '' &&
            this.employeeLeaves.toDate != ''  &&
            this.employeeLeaves.noOfDays != 0 &&
            this.employeeLeaves.approversLMs != [] &&
            ((this.employeeLeaves.reason != '' && 
                this.leaveTypeName.isAttachment == true &&
                this.employeeLeaves.noOfDays >= this.leaveTypeName.maxCountForAttachment &&
                this.countFiles() > 0) ||
            (this.employeeLeaves.reason != '' && this.leaveTypeName.isAttachment == true && this.employeeLeaves.noOfDays < this.leaveTypeName.maxCountForAttachment) || this.leaveTypeName.isAttachment == false) 

            
        },
        disabledDatesTo() {
            return {  to: new Date(this.employeeLeaves.fromDate)} //{ to: new Date(this.fromDate) }
        },
        disabledDatesFrom() {
            return { from: new Date(this.employeeLeaves.toDate) }
        },
        getLeaveTypes() {
            return this.$store.state.lookup.getAllLeaveTypes
        },
        getLeaveBenefits() {
            let eb = []
            const e = this.$store.state.hrms.employeeLeaveBenefits

            e.forEach(lb => {
                // console.log(this.leaveType(lb.leaveTypeId))
                if(this.checkDateHired >= this.leaveType(lb.leaveTypeId).leaveAvailAfterHowManyMonths)
                eb.push(lb.leaveType)
            })
            // for(var e =0; e < this.$store.state.hrms.employeeLeaveBenefits.length; e++ ) {
            //     console.log(this.getEmployeeInformation.leaveAvailAfterHowManyMonths)
            //     if((this.checkDateHired >= this.leaveTypethis.getEmployeeInformation.leaveAvailAfterHowManyMonths) || this.getEmployeeInformation.leaveAvailAfterHowManyMonths <= 0 )
            //     eb.push(this.$store.state.hrms.employeeLeaveBenefits[e].leaveType)
            // }
            return eb
        },
        getEmployeeLeaveBalance() {
            return this.$store.state.hrms.employeeLeaveBalance
        },
        getApprovers() {
            let approver = []
            this.$store.state.leavemanagement.approvers.forEach(a => {
                if(a.isActive)
                    approver.push(a.approver)
            })
           
           
            return approver
        },
        leaveType() {
            console.log(this.$store.state.lookup.getAllLeaveTypes)
             return (leaveTypeId) => this.$store.getters['lookup/leaveTypeLookup'](leaveTypeId)
        },
        approverName: {
            get() { let approversName = [] 
                    let approvers = this.employeeLeaves.approversLMs
                    approvers.forEach(a => {
                        approversName.push(this.$store.getters['leavemanagement/approverName'](a).approver)
                    })
                return  approversName },
            set(obj) { 
                let approver = []
                this.employeeLeaves.approversLMs =[] 
                        obj.forEach(u => {
                            approver.push(u.userId)
                         })
                this.employeeLeaves.approversLMs = approver
            }
        },
        tenantName: {
            get() { return this.$store.getters['tenants/tenantName'](this.employeeLeaves.tenantsId)  },
            set(obj) { this.employeeLeaves.tenantsId = obj.tenantsId }
        },
        leaveTypeName: {
            get() { //this.leaveTypeName.maxCountForAttachment = 0
                    return this.$store.getters['lookup/leaveTypeLookup'](this.employeeLeaves.leaveTypeId) },
            set(obj) { this.employeeLeaves.leaveTypeId = obj.leaveTypeId}
        },
        validRemarks(){
            return (this.employeeLeaves.remarks.length > 0)
        },
        getCurrentDate() {
            return moment(new Date()).utc().format("YYYY-MM-DD")
        },
        scrollbarTag () { return this.$store.getters.scrollbarTag },
        onGetStatus() {
             return (data) => {
                var leaveStatus = ''
                var c = data.approversLMs.length
                data.approversLMs.forEach((a) => {
                    if(a.isApproved && a.priorityId == 1){
                        if(c > 1) {
                            leaveStatus = 'Partially Approved'
                        }
                        else
                            leaveStatus = 'Approved'
                    } else if(a.isApproved && a.priorityId == 2){
                        if(c > 2) {
                            leaveStatus = 'Partially Approved'
                        }
                        else
                            leaveStatus = 'Approved'
                    }else if (data.isCancelled) {
                        leaveStatus = 'Cancelled'
                    } else if(a.isRevised) { 
                        leaveStatus = 'For Revision'
                    }else if(data.isRetracted) { 
                        leaveStatus = 'Retracted'
                    }else if(a.isDenied) { 
                        leaveStatus = 'Denied'
                    }else if (data.isDraft) {
                        leaveStatus = 'Draft'
                    }else if (data.isSubmitted && leaveStatus == '') {
                        leaveStatus = 'Pending'
                    }
                })
                return leaveStatus
             }
        },
        
        getFromDate(){
            return (fromDate) => moment(fromDate).format('YYYY-MM-DD')
        },
        checkLeaveBalance() {
            return (leaveTypeId) => {
                var lt = this.leaveType(leaveTypeId)
                let leaveRequest = this.getEmployeeLeaveRequests
                var leavesTaken = 0

                leaveRequest.forEach(l => {
                    if(l.leaveTypeId == leaveTypeId) {
                        if(this.onGetStatus(l) != 'Cancelled' || 
                        this.onGetStatus(l) != 'Retracted' ||
                        this.onGetStatus(l) != 'Denied')
                            leavesTaken += l.noOfDays
                    }
                })

                let leavesBalance = this.getEmployeeLeaveBalance
                var leavesCredited = 0

                leavesBalance.forEach(l => {
                    // if(l.leaveTypeId == leaveTypeId  && leavesCredited <= lt.maxDays)
                    if(l.leaveTypeId == leaveTypeId)
                        leavesCredited += l.leaveDays
                })

                //  if(leavesCredited > lt.maxDays)
                //     leavesCredited = leavesCredited - (leavesCredited - lt.maxDays)

                return leavesCredited - leavesTaken - this.employeeLeaves.noOfDays
            }
           
        }
        

    },
    methods: {
        promptAddNewLeave(){
            this.clearFields()
            this.getDefaultApprover()
            this.activePromptAddLeave = true
        },
        onAddLeave() {
            if(!this.checkIfOverlap(this.employeeLeaves.fromDate, this.employeeLeaves.toDate, null)) return
             if(this.checkLeaveBalance(this.employeeLeaves.leaveTypeId) <= 0 && this.leaveTypeName != null && this.employeeLeaves.leaveTypeId != 8){
                //  this.$alert('You do not have leave balance left, apply for <b>Unpaid Leave</b> instead','Cannot Proceed', 'error')
                Swal.fire({
                    title: 'Cannot Proceed!',
                    icon: 'error',
                    html:'You do not have leave balance left, apply for <b>Unpaid Leave</b> instead' 
                        
                    })
                 return
             }
            this.setFormData()
            this.onDisabledDates()
            this.uploadFiles()
                    
        },
        uploadFiles() {
            
            if(this.leaveTypeName.isAttachment && 
               this.formData !== null && 
               this.employeeLeaves.noOfDays >= this.leaveTypeName.maxCountForAttachment  ) {
                
                if(this.countFiles() <= 0) {
                    // this.$alert('Attachment is empty', 'Leave request', 'warning')
                    this.$vs.loading.close()
                    this.$vs.notify({
                            title: 'Error',
                            text: 'Attachment is empty',
                            iconPack: 'feather',
                            icon: 'icon-x-octagon',
                            color: 'danger'
                    })
                    return
                }  
                this.$vs.loading() 
                this.$store.dispatch('uploadFile', this.formData)
                    .then((response) => {
                        this.$vs.loading.close()
                        if(response.status == 200){
                            this.employeeLeaves.fileId = response.data.item2
                            this.addLeave()
                        }
                            
                    })
                    .catch((error) => {
                        this.$vs.loading.close()
                        console.log(error.message)
                        
                        
                    })
                
            } else this.addLeave()
            this.$vs.loading.close()
        },
        addLeave() {
            this.$vs.loading()

            if(this.employeeLeaves.isDraft) {
                this.employeeLeaves.isDraft = true
                this.employeeLeaves.isSubmitted = false
                this.employeeLeaves.submittedOn = null
            }else {
                this.employeeLeaves.submittedOn = new Date()
                // this.employeeLeaves.fileId = '3c4316a7-979d-4dda-9106-e99b7a76b1de,e7fb4f86-d79e-4f84-b8b0-c9c48afd4c62'
            }
            this.$store.dispatch('leavemanagement/addLeave', this.employeeLeaves )
            .then((response) => {
                this.$vs.loading.close()
                if(response.status == 200)
                {
                    if(this.isDraft)
                        this.$alert("You have successfully created your leave request and saved as draft", 'Draft Save Successfully', "success")
                    else 
                        this.$alert("You have successfully submitted your leave request", 'Leave Submitted', "success")
                    
                }
                else
                    this.$alert("", response.statusText, "error")
            })
            .catch(error => {
                    this.$vs.loading.close()
                    this.$alert( error.message, "Error", "error")
            })
            
        },
        onEditRecord(filedLeaveId){
            this.clearFields()

            const e = this.$store.getters['leavemanagement/employeeFiledLeave'](filedLeaveId)

            this.employeeLeaves.employeeFiledLeaveId = e.employeeFiledLeaveId,
            this.employeeLeaves.leaveTypeId = e.leaveTypeId,
            this.employeeLeaves.fromDate = moment(e.fromDate).format('YYYY-MM-DD'),
            this.employeeLeaves.toDate = moment(e.toDate).format('YYYY-MM-DD'),
            this.employeeLeaves.isMorningFrom= e.isMorningFrom,
            this.employeeLeaves.isMorningTo= e.isMorningTo,
            this.employeeLeaves.noOfDays= e.noOfDays,
            this.employeeLeaves.hours= e.hours,
            this.employeeLeaves.minutes= e.minutes,
            this.employeeLeaves.reason= e.reason,
            this.employeeLeaves.isDraft= e.isDraft,
            this.employeeLeaves.isSubmitted= e.isSubmitted,
            this.employeeLeaves.submittedOn= e.submittedOn,
            this.employeeLeaves.isCancelled= e.isCancelled,
            this.employeeLeaves.cancelledOn= e.cancelledOn,
            this.employeeLeaves.fileId = e.fileId,
            this.employeeLeaves.subscriptionId= e.subscriptionId,
            this.employeeLeaves.approversLMs = e.approversLMs.map(u => u.approverId).join(',').split(',')

            if(e.fileId != '')
            this.getAttachmentName(e.fileId.split(','))
            this.onDisabledDates()
            this.activePromptEditLeave = true
        },
        onUpdateLeave() {
            this.$vs.loading()
            this.$store.dispatch('leavemanagement/updateLeave', this.employeeLeaves)
            .then((response)=> {
                this.$vs.loading.close()
                if(response.status == 200)
                {
                    if(this.isDraft)
                        this.$alert("You have successfully updated your leave request and saved as draft", 'Draft Save Successfully', "success")
                    else 
                        this.$alert("You have successfully submitted your leave request", 'Leave Submitted', "success")
                }
                else
                    this.$alert("", response.statusText, "error")

            })
            .catch(error => {
                    this.$vs.loading.close()
                    this.$alert( error, "Error", "error")
                })

        },
        onUnSubmit(filedLeaveId, approvers) {
            Swal.fire({
              title: 'Are you sure you want to <strong>continue</strong>?' ,
              text: "",
              icon: 'warning',
              customClass: {
                  icon: "no-before-icon",
              },
              showCancelButton: true,
              confirmButtonColor: '3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Un-Submit'
            }).then((result) => {
              if (result.isConfirmed) {
                    this.$vs.loading()
                    const data = {
                        employeeFiledLeaveId: filedLeaveId,
                        action: "UNSUBMIT",
                        isDraft : true,
                        isSubmitted: false,
                        approverId: approvers.map(u => u.approverId).join(',')
                    }
                    this.$store.dispatch('leavemanagement/unSubmit', data)
                    .then((response) => {
                        this.$vs.loading.close()
                        if(response.status == 200)
                            this.$alert("You have successfully un-submit your leave request", 'Un-Submit Successfully', "success")
                        else
                                this.$alert("", response.statusText, "error")
                })
                    .catch((error) => {
                            this.$vs.loading.close()
                            this.$alert( error.message, "Error", "error")
                    })
                } else
                    this.$alert("", 'Cancelled', "success")
            })
            
        },
        onRetracted(filedLeaveId, approvers) {
            Swal.fire({
              title: 'Are you sure you want to <strong>continue</strong>?' ,
              text: "You will not be able to revert this, but you can still use the same date unless denied or taken",
              input: 'text',
              inputPlaceholder:'Enter Remarks',
              icon: 'warning',
              customClass: {
                  icon: "no-before-icon",
              },
              showCancelButton: true,
              confirmButtonColor: '3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Retract',
               inputValidator: (value) => {
                    return new Promise((resolve) => {
                        if (value !== '') {
                            resolve()
                        } else {
                            resolve('Remarks is Required!')
                        }
                    })
              }
            }).then((result) => {
              if (result.isConfirmed) {
                    this.$vs.loading()
                    this.employeeLeaves.remarks = result.value
                    const data = {
                        employeeFiledLeaveId: filedLeaveId,
                        action: "RETRACKED",
                        isDraft : false,
                        isRetracted : true,
                        retractedOn : this.getCurrentDate,
                        isApproved: false,
                        remarks : this.employeeLeaves.remarks,
                        approverId: approvers.map(u => u.approverId).join(',')
                    }
                    this.$store.dispatch('leavemanagement/onRetracked', data)
                    .then((response) => {
                            this.$vs.loading.close()
                            if(response.status == 200)
                                this.$alert("You have successfully retracted your leave request", 'Retracted Successfully', "success")
                            else 
                                this.$vs.loading.close()
                        })
                    .catch((error) => {
                            this.$vs.loading.close()
                            this.$alert( error.message, "Error", "error")
                        })
                } else
                    this.$alert("", 'Cancelled', "success")
            })   
                

        },
        onCancelled(filedLeaveId, approvers) {
             Swal.fire({
              title: 'Are you sure you want to <strong>continue</strong>?' ,
              text:'',
              input: 'text',
              inputPlaceholder:'Enter Remarks',
              icon: 'warning',
              customClass: {
                  icon: "no-before-icon",
              },
              showCancelButton: true,
              confirmButtonColor: '3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Cancel Request',
              inputValidator: (value) => {
                    return new Promise((resolve) => {
                        if (value !== '') {
                            resolve()
                        } else {
                            resolve('Remarks is Required!')
                        }
                    })
              }

            }).then((result) => {
              if (result.isConfirmed) {
                    this.$vs.loading()
                    this.employeeLeaves.remarks = result.value
                    
                    const data = {
                        employeeFiledLeaveId: filedLeaveId,
                        action: "CANCELLED",
                        isDraft : false,
                        isSubmitted: false,
                        isCancelled : true,
                        cancelledOn : this.getCurrentDate,
                        isRevised : false,
                        remarks : this.employeeLeaves.remarks,
                        approverId: approvers.map(u => u.approverId).join(',')
                    }
                    this.$store.dispatch('leavemanagement/onCancelled', data)
                    .then((response) => {
                            this.$vs.loading.close()
                            if(response.status == 200)
                                this.$alert("You have successfully cancelled your leave request", 'Cancelled Successfully', "success")
                            else
                                this.$alert("", response.statusText, "error")
                        })
                    .catch((error) => {
                            this.$vs.loading.close()
                            this.$alert(error.message, "Error", "error")
                        })

                } else
                    this.$alert("", 'Cancelled', "info")
            })
                

        },
        getDefaultApprover() {
            var approver = this.getApprovers
            this.approverName = approver
        },
        clearFields() {
            this.leaveTypeName = this.employeeLeaves.noOfDays = this.employeeLeaves.fileId = this.employeeLeaves.fromDate = this.employeeLeaves.toDate =  this.employeeLeaves.reason = ""
            this.employeeLeaves.approversLMs = []
           
        },
        
        onFromChange(selectedDates, dateStr, instance) {
            
            this.$set(this.configTodateTimePicker, 'minDate', dateStr);
        },
        onToChange(selectedDates, dateStr, instance) {
            this.$set(this.configFromdateTimePicker, 'maxDate', dateStr);
        },
        onFilesSelected(event) {
            console.log(event)
        },
        setFormData(){
            this.formData = new FormData()
            let file = Array.from(this.$refs.uplodfle.filesx)

            file.forEach(f => {
                if(f.type === 'application/x-msdownload') {
                    this.$vs.notify({
                        title: 'Info',
                        text: "File not allowed",
                        iconPack: 'feather',
                        icon: 'icon-x-octagon',
                        color: 'warning'
                        })
                    return
                }
                
                if(!f.remove)
                {   
                    this.formData.append('UserId',  this.$store.state.AppActiveUser.uid)
                    this.formData.append('Title', this.leaveTypeName.leaveTypeName)
                    this.formData.append('Description', this.employeeLeaves.reason)
                    this.formData.append('Path', "")
                    this.formData.append('BlobContainer', "")
                    this.formData.append('OrigFilename', f.name)
                    this.formData.append('ContentType', f.type)
                    this.formData.append('Tags', "")
                    this.formData.append('file', f)
                } 

            })
        },
        onSuccessUpload(event) {
            this.$vs.notify({color:'success',title:'Upload Success',text:'Lorem ipsum dolor sit amet, consectetur'})
        },
        onDeleteFile(event, index) {
            console.log(event)
            console.log(index)
            // let file = Array.from(this.$refs.uplodfle.filesx)

            // file.forEach((f,i) => {
            //     console.log(f)
            //     console.log(i)
            //     if(f.remove)
            //         f.splice(i, 1)
            // })

            // console.log(file)
        },
        checkIfOverlap(f, t, id) {
            this.isOverlapped = false

            var f = moment(f).format("YYYY-MM-DD")
            var t = moment(t).format("YYYY-MM-DD")
            for(var x = 0; x < this.getEmployeeLeaveRequests.length ; x++)
            {
                let approver = this.getEmployeeLeaveRequests[x].approversLMs

                approver.forEach(a => {
                    if((a.isApproved || this.getEmployeeLeaveRequests[x].isDraft ||
                        this.getEmployeeLeaveRequests[x].isSubmitted || a.isRevised) &&
                        (!a.isDenied && !a.isRetracted))
                    {
                        var date1 = moment(this.getEmployeeLeaveRequests[x].fromDate).format('YYYY-MM-DD');
                        var date2 = moment(this.getEmployeeLeaveRequests[x].toDate).format('YYYY-MM-DD');
                    
                        if ((date1 <= f && t <= date2) ||
                            (date1 >= f && t >= date2) ||
                            (date1 >= f && t >= date1) ||
                            (date2 >= f && t >= date2)) {
                                        //console.log('overlapped')
                                if (this.getEmployeeLeaveRequests[x].employeeFiledLeaveId != id)
                                    this.isOverlapped = true
                            }
                    }

                })
                
                if(this.isOverlapped) {
                    this.$vs.notify({
                    title: 'Overlapped',
                    text: 'You already filed leaves on that date',
                    iconPack: 'feather',
                    icon: 'icon-x-octagon',
                    color: 'danger'
                    })
                    return false
                }

            }
            return true
        },
        downloadFile(fileId){
            var file = fileId.split(',')
            file.forEach(f => {
                 this.$store.dispatch('downloadFile', f)
                .then((response) => {
                    // console.log(response.headers['content-disposition'].split('filename=')[1].split('\;')[0])
                    let fileName = response.headers['content-disposition'].split('filename=')[1].split('\;')[0]
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.download = fileName.replace('"', '').replace('"', '')
                    // link.setAttribute('download', fileName )
                    // document.body.appendChild(link);
                    link.click();
                })
            })
           
        },
        getAttachmentName(fileId){
            this.attachmentName = []
            fileId.forEach(f => {
                // console.log(f)
                this.$store.dispatch('downloadFile', f)
                .then((response) => {
                    // console.log('GETATTACHMENT')
                    // console.log(response)
                    let fileName = response.headers['content-disposition'].split('filename=')[1].split('\;')[0]
                    let fId = response.config['url'].split('/api/file/download?fileId=')[1]
                    this.attachmentName.push({value: fId, label: fileName.replace('"', '').replace('"', ''),})
                    
                })
            })
            
        },
        getDateDiff(){
                
                var oneDay = 1
                var ampm = 0
                var days = []
                this.hours = 0
                if((this.employeeLeaves.isMorningFrom && this.employeeLeaves.isMorningTo) || (!this.employeeLeaves.isMorningFrom && !this.employeeLeaves.isMorningTo))
                {
                    ampm = 0.5

                } 
                
                oneDay = oneDay - ampm

                if (this.employeeLeaves.fromDate !== null && this.employeeLeaves.toDate !== null) {
                        var date1 = new Date(moment(this.employeeLeaves.fromDate).format("MM-DD-YYYY"))
                        var date2 = new Date(moment(this.employeeLeaves.toDate).format("MM-DD-YYYY"))
                

                        var timeDiff = Math.abs(date2.getTime() - date1.getTime())
                        var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24))
                        if (diffDays !== 'NaN') {
                            this.employeeLeaves.noOfDays = diffDays + oneDay;
                        }  
                            
                    for (var i = 0; i < this.employeeLeaves.noOfDays; i++) {
                        var d = new Date();
                        d.setDate(date1.getDate() + i );
                        var x = new Date(moment(d).format('YYYY-MM-DD'))

                        var dname = this.$store.getters['tenants/tenantsScheduleByDayName'](x.getDay()+1)
                        this.employeeLeaves.hours += dname.workedHours
                    
                    }              
                } 
                isNaN(this.employeeLeaves.noOfDays) ? this.employeeLeaves.noOfDays = 0 : this.employeeLeaves.noOfDays

               
        },
        onDisabledDates(){
            //console.log('START')
            this.disabledDates =[]
            let x = 0
            let y = 0
            let ranges = []

            var leaves = this.getEmployeeLeaveRequests

            leaves.forEach(l => {
                 l.approversLMs.forEach(a => {
                     if(!a.isDenied && !l.isCancelled) 
                    {
                         if(moment(l.fromDate).format('YYYY-MM-DD') == moment(this.employeeLeaves.fromDate).format('YYYY-MM-DD') && moment(l.toDate).format('YYYY-MM-DD') == moment(this.employeeLeaves.toDate).format('YYYY-MM-DD'))
                        {
                        
                        } else {
                            x = moment(l.fromDate, 'YYYY-MM-DD')
                            y = moment(l.toDate, 'YYYY-MM-DD')
                            // y = moment(l.toDate, 'YYYY-MM-DD').add(1, 'days')

                            ranges.push({ 
                                from : new Date(moment(x).format('YYYY'), moment(x).add(-1, 'M').format('M'), moment(x).format('DD')),
                                to : new Date(moment(y).format('YYYY'), moment(y).add(-1, 'M').format('M') , moment(y).format('DD'))
                            })
                        }
                    }
                 })
            })

            this.configFromdateTimePicker.disable = JSON.parse(JSON.stringify(ranges))
            this.configTodateTimePicker.disable = JSON.parse(JSON.stringify(ranges))
            
            // this.disabledDates = {
            //     disabledDates: {
            //         ranges: ranges,
            //     }
            // }
        },
        countFiles() {
            console.log('TINAWAG2')
            var count = 0
            let file = Array.from(this.$refs.uplodfle.filesx)
            file.forEach(f => {
                if(!f.remove)
                {   
                   count += 1
                } 
                console.log(f)
            })
            console.log('count')
            console.log(count)
            return count
        }
    
    },
    components: {
        'v-select': vSelect,
        Datepicker,
        flatPickr,
        VuePerfectScrollbar,
    },
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/email.scss";
// @import "@/assets/scss/vuexy/apps/simple-calendar.scss";
</style>